import getEnv from "@workspace/nextjs_utils/src/getEnv";
import getGraphqlEndpoint from "../getGraphqlEndpoint";
import mapHttpsUriToWss from "../mapHttpsUriToWss";
import CustomSubscriptionClient from "./CustomSubscriptionClient";

declare global {
  // One socket per page, shared by every subscription hook.
  var subscriptionClient:
    | import("subscriptions-transport-ws").SubscriptionClient
    | undefined;
}

const getSubscriptionClient = () => {
  globalThis.subscriptionClient =
    globalThis.subscriptionClient ?? createClient();
  return globalThis.subscriptionClient;
};

const createClient = () => {
  const graphqlUri = getGraphqlEndpoint();
  const uri = mapHttpsUriToWss(graphqlUri);
  const wsUri = getEnv("WS_GRAPHQL_SERVER_URL") ?? uri;
  return new CustomSubscriptionClient(wsUri, { reconnect: true, lazy: true });
};

export default getSubscriptionClient;
